
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockApproveDisassembleGrid extends Serenity.EntityGrid<IcStockApproveDisassembleRow, any> {
        protected getColumnsKey() { return IcStockApproveDisassembleColumns.columnsKey; }
        protected getDialogType() { return IcStockApproveDisassembleDialog; }
        protected getIdProperty() { return IcStockApproveDisassembleRow.idProperty; }
        protected getInsertPermission() { return IcStockApproveDisassembleRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockApproveDisassembleRow.localTextPrefix; }
        protected getService() { return IcStockApproveDisassembleService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)

            
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcStockApproveDisassembleService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}